exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.start-time .el-form-item__label:before {\n  display: none;\n}\n", ""]);

// exports
